// Converts decimal feet to ft-in notation: 9.5 → "9'-6"", 6.833 → "6'-10""
export function ftIn(decimalFeet) {
  if (decimalFeet === null || decimalFeet === undefined || decimalFeet === '') return '—';
  const val = parseFloat(decimalFeet);
  if (isNaN(val)) return String(decimalFeet);
  const totalInches = Math.round(val * 12);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  if (inches === 0) return `${feet}'-0"`;
  return `${feet}'-${inches}"`;
}

// Converts ft-in string back to decimal for inputs: "9'-6"" → 9.5
export function parseFtIn(str) {
  if (!str) return '';
  const match = String(str).match(/^(\d+)['-](\d+)"?$/);
  if (match) return parseFloat(match[1]) + parseInt(match[2]) / 12;
  return parseFloat(str) || '';
}
